import type { Dict } from "./pl.js";

export const fr: Dict = {
  navCats: "Catégories",
  navHow: "Comment ça marche",
  navOps: "Pour les professionnels",
  navPrice: "Tarifs",
  navContact: "Contact",
  navBook: "Démo de l’espace pro",
  pill: "La plateforme de réservation des professionnels de services",
  title1: "Vos prestations.",
  title2: "Se réservent seules.",
  sub: "b00k réunit tous vos calendriers — chambres, véhicules, rendez-vous — dans un seul système de réservation. Vos clients réservent eux-mêmes par le web et le chat, et le système surveille les créneaux et bloque les conflits.",
  ctaBook: "Créer un compte professionnel",
  ctaOperator: "Voir la vue client",
  heroMeta: "VOTRE-ENTREPRISE.B00K.ONLINE · CHAQUE PROFESSIONNEL A SON SOUS-DOMAINE",
  cardChip: "Confirmée",
  cardNote: "Les réservations arrivent seules — du web et du chat — et bloquent le planning aussitôt.",
  catsKick: "CATÉGORIES DE PRESTATIONS",
  catsTitle: "Ce que vous gérez avec b00k",
  catsSub: "Une plateforme pour toutes vos prestations. Celles à l’heure s’enchaînent ; chambres et véhicules se réservent en parallèle, à la journée.",
  cat1t: "Chambres",
  cat1d: "Chambres et appartements pour une ou plusieurs nuits. Plusieurs chambres se réservent en parallèle sur les mêmes dates.",
  cat2t: "Véhicules",
  cat2d: "Citadines et SUV à la journée. Le calendrier de disponibilité surveille les départs et les retours.",
  cat3t: "Loisirs",
  cat3d: "Sauna, spa, kayaks. Réservation à une heure précise, pour une durée définie.",
  cat4t: "Coiffure",
  cat4d: "Coupe et couleur. Vous choisissez l’heure — le système bloque exactement la durée de la prestation.",
  cat5t: "Esthétique",
  cat5d: "Manucure et massages. Combinables avec d’autres prestations — les durées fusionnent en un seul bloc.",
  cat6t: "Santé",
  cat6d: "Consultations et examens à heure fixe. Le calendrier du cabinet se tient à jour tout seul.",
  cat7t: "Atelier",
  cat7d: "Voiture, vélo ou ordinateur portable — nous couvrons tout.",
  cat8t: "Cours particuliers",
  cat8d: "Cours de langue ou de piano — organisez-les sur notre plateforme.",
  cat9t: "Autre",
  cat9d: "Les spécificités de votre métier + notre expérience = la réussite.",
  howKick: "COMMENT ÇA MARCHE",
  howTitle: "Trois étapes, zéro appel",
  s1t: "Ajoutez prestations et ressources",
  s1d: "Listez chambres, véhicules et rendez-vous avec durées et tarifs. Le système vérifie chaque compte à l’inscription — le vôtre comme celui de vos clients.",
  s2t: "Les clients réservent seuls",
  s2d: "Par le web ou le chat — WhatsApp et Messenger. Les durées s’additionnent, les chambres se réservent en parallèle, et seuls les créneaux réellement libres s’affichent.",
  s3t: "Le système surveille le planning",
  s3d: "Dès la confirmation, le créneau est bloqué — deux personnes ne peuvent jamais réserver la même prestation au même moment. Annulations et reports compris.",
  newChip: "Nouveau",
  chatLine: "Vos clients peuvent réserver en discutant — via WhatsApp ou Messenger.",
  opsKick: "POUR LES PROFESSIONNELS",
  opsTitle: "Votre planning travaille pour vous",
  opsSub: "Chambres, véhicules et rendez-vous dans un seul calendrier. Les conflits sont bloqués automatiquement, les réservations par chat arrivent seules, et vous suivez le taux d’occupation et le chiffre d’affaires en direct.",
  opsCta: "Voir l’espace professionnel",
  f1: "Calendrier du jour et occupation des ressources en une vue",
  f2: "Blocage automatique des conflits de réservation",
  f3: "Réservations du web et du chat — WhatsApp / Messenger",
  f4: "Clients, notes de réservation et indicateurs",
  priceKick: "TARIFS",
  priceTitle: "Aussi simple qu’une réservation",
  month: "mois",
  recommended: "Recommandé",
  soon: "BIENTÔT DISPONIBLE",
  custom: "Sur devis",
  opsSuffix: "collaborateurs",
  priceNote: "Le prix mensuel dépend du nombre de collaborateurs ayant accès à l’espace pro.",
  t1f1: "Calendrier et réservations en ligne",
  t1f2: "Chat WhatsApp / Messenger",
  t1f3: "Clients, notes et rappels",
  t2f1: "Tout ce qu’offre SOLO",
  t2f2: "Ressources et prestations sans limite",
  t2f3: "Rapports et indicateurs d’occupation",
  t3f1: "Tout ce qu’offre TEAM",
  t3f2: "Plannings et rôles des collaborateurs",
  t3f3: "API et intégrations",
  t4f1: "Tout ce qu’offre GROUP",
  t4f2: "Accompagnement au déploiement et SLA",
  t4f3: "Contrat et facturation sur mesure",
  conKick: "CONTACT & ACCÈS",
  conTitle: "Votre adresse, leur itinéraire",
  dirKick: "ACCÈS — TEL QUE VOS CLIENTS LE VERRONT",
  dir1: "En voiture : route nationale 3 depuis Jelenia Góra, sortie Szklarska Poręba Centrum, puis 5 minutes par la rue Zdrojowa.",
  dir2: "En train : gare de Szklarska Poręba Górna, 12 minutes à pied vers le centre.",
  dir3: "Parking gratuit sur place — sans frais ni réservation.",
  footUser: "Vue client",
  footOp: "Espace professionnel",

  wizTitle: "Créer un compte professionnel",
  wizSub: "Sept étapes. À la fin, vous avez votre sous-domaine et un espace prêt à l’emploi.",
  wizStep1: "Entreprise",
  wizStep2: "Sous-domaine",
  wizStep3: "Secteurs",
  wizStep4: "Formule",
  wizStep5: "Administrateur",
  wizStep6: "Paiements",
  wizStep7: "Récapitulatif",
  wizNext: "Suivant",
  wizBack: "Retour",
  wizFinish: "Créer le compte",
  fCompany: "RAISON SOCIALE",
  fNip: "NUMÉRO FISCAL (NIP)",
  fPhone: "TÉLÉPHONE",
  fAddress: "ADRESSE",
  fSlug: "SOUS-DOMAINE",
  slugHint: "L’adresse à laquelle vos clients réserveront vos prestations.",
  slugChecking: "Vérification de la disponibilité…",
  slugFree: "Le sous-domaine est libre.",
  slugTaken: "Ce sous-domaine est déjà pris.",
  slugInvalid: "Sous-domaine : 3 à 63 caractères, minuscules, chiffres et tiret (ni au début ni à la fin).",
  industriesHint: "Choisissez les secteurs que vous couvrez. Vous pourrez en ajouter d’autres depuis l’espace pro.",
  planHint: "Vous changez de formule à tout moment — sans perdre de données.",
  fName: "NOM ET PRÉNOM",
  fEmail: "E-MAIL",
  fPass: "MOT DE PASSE (8 CARACTÈRES MIN.)",
  fPass2: "CONFIRMER LE MOT DE PASSE",
  fTerms: "J’accepte les conditions de b00k.online et consens au traitement des données aux fins de gestion des réservations.",
  payTitle: "Paiements des clients",
  payHint: "Facultatif. Vous pouvez encaisser en ligne au moment de la confirmation.",
  payEnable: "Accepter les paiements en ligne",
  payMethods: "MOYENS DE PAIEMENT",
  sumTitle: "Récapitulatif",
  sumCompany: "ENTREPRISE",
  sumSub: "SOUS-DOMAINE",
  sumIndustries: "SECTEURS",
  sumPlan: "FORMULE",
  sumAdmin: "ADMINISTRATEUR",
  sumPayments: "PAIEMENTS",
  yes: "Oui",
  no: "Non",
  doneTitle: "Votre compte professionnel est prêt",
  doneSub: "Votre sous-domaine est en ligne. Connectez-vous à l’espace pro et ajoutez vos prestations — les réservations démarrent aussitôt.",
  doneOpen: "Ouvrir l’espace professionnel",
  doneBooking: "Voir la page de réservation",
  companyProofOk: "Connecté en tant qu’administrateur de l’entreprise :",
  companyLoginOther: "Se connecter avec un autre compte",
  errGeneric: "La création du compte a échoué. Vérifiez les données et réessayez.",
};
